import type { MapRegion, RegionId } from "@/types"
import { kazdelRegion } from "./kazdel"
import { leithaniaRegion } from "./leithania"
import { rhodesRegion } from "./rhodes"
import { samiRegion } from "./sami"
import { sargonRegion } from "./sargon"
import { ursusRegion } from "./ursus"
import { victoriaRegion } from "./victoria"

export const allRegions: MapRegion[] = [
    sargonRegion,
    samiRegion,
    ursusRegion,
    victoriaRegion,
    leithaniaRegion,
    kazdelRegion,
    rhodesRegion,
]

export function createRegions(): MapRegion[] {
    return allRegions.map((region) => ({
        ...region,
        iconConfig: { ...region.iconConfig },
    }))
}

export function getRegionById(id: RegionId): MapRegion | undefined {
    return allRegions.find((r) => r.id === id)
}

export function getNextUnlockedRegion(
    currentOrder: number,
): MapRegion | undefined {
    return allRegions
        .filter((r) => r.order > currentOrder && r.unlocked)
        .sort((a, b) => a.order - b.order)[0]
}
